<div class="background-image-sizer">
  <img class="login-image" src="../../../assets/support.jpg" alt="" />
</div>
